import config from "config.json";
import { PointLight, PointLightHelper } from "three";
import type { QualityKeys } from "@/types/global.types";
import { animateValue } from "../../engine/lights/utils";
import { bonfireConf } from "./configs";
import type { FireLight } from "./types";

export const createFireLight = (): FireLight => {
  const { defMapSize, mapSizes } = config.scene.renderer.shadows;
  const lightConfg = bonfireConf.fireLight;
  const mapSize = mapSizes[defMapSize as QualityKeys].mapSize;

  const light = new PointLight(
    lightConfg.color,
    lightConfg.intensity,
    lightConfg.distance,
    lightConfg.decay
  );

  light.castShadow = true;
  light.shadow.mapSize.set(mapSize, mapSize);
  light.shadow.bias = mapSizes[defMapSize as QualityKeys].bias.high;
  light.shadow.normalBias = mapSizes[defMapSize as QualityKeys].bias.normal;

  light.position.set(
    lightConfg.position.x,
    lightConfg.position.y,
    lightConfg.position.z
  );

  const helper = new PointLightHelper(light, lightConfg.helper.size);

  //animation
  const animator = {
    update: (e: number) => {
      light.intensity = animateValue(
        lightConfg.intensity,
        lightConfg.animation.intensity,
        e
      );
      light.distance = animateValue(
        lightConfg.distance,
        lightConfg.animation.distance,
        e
      );
      light.position.y = animateValue(
        lightConfg.position.y,
        lightConfg.animation.position,
        e
      );
    }
  };

  return { light, helper, animator };
};
